import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

class ConfirmDialog extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    icon: PropTypes.node.isRequired,
    text: PropTypes.node.isRequired,
    confirmText: PropTypes.string,
    cancelButtonText: PropTypes.node,
    confirmButtonText: PropTypes.node,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    confirmText: null,
    cancelButtonText: null,
    confirmButtonText: null,
    onCancel: () => {},
  };

  state = {
    value: '',
  };

  componentDidMount() {
    const { id, onCancel } = this.props;

    /* eslint-disable no-undef */
    $(`#${id}`).on('hide.bs.modal', () => {
      onCancel();
    });
    /* eslint-enable no-undef */
  }

  onChange = event => {
    this.setState({ value: event.target.value });
  };

  render() {
    const {
      id,
      icon,
      text,
      confirmText,
      cancelButtonText,
      confirmButtonText,
      onConfirm,
    } = this.props;

    const { value } = this.state;

    return (
      <div
        id={id}
        className="modal modal-mini modal-primary fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby={`${id}Label`}
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <div className="modal-profile d-flex justify-content-center align-items-center">
                {icon}
              </div>
            </div>

            <div className="modal-body">
              <p>{text}</p>

              {confirmText && (
                <div>
                  <p>
                    <FormattedHTMLMessage
                      id="confirmdialog-verify"
                      defaultMessage="Vahvista kirjoittamalla <b><i>{text}</i></b>"
                      values={{
                        text: confirmText,
                      }}
                    />
                  </p>

                  <input
                    type="text"
                    onChange={this.onChange}
                    value={value}
                    className="form-control bg-white"
                  />
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-link btn-neutral"
                data-dismiss="modal"
              >
                {cancelButtonText || (
                  <FormattedMessage
                    id="confirmdialog-cancel"
                    defaultMessage="Peruuta"
                  />
                )}
              </button>

              <button
                type="button"
                className="btn btn-link btn-neutral"
                onClick={onConfirm}
                disabled={confirmText && value !== confirmText}
                data-dismiss="modal"
              >
                {confirmButtonText || (
                  <FormattedMessage
                    id="confirmdialog-confirm"
                    defaultMessage="Vahvista"
                  />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ConfirmDialog;
